import { render, staticRenderFns } from "./OperatingCurrenciesTab.vue?vue&type=template&id=31701c30&scoped=true"
import script from "./OperatingCurrenciesTab.vue?vue&type=script&lang=js"
export * from "./OperatingCurrenciesTab.vue?vue&type=script&lang=js"
import style0 from "./OperatingCurrenciesTab.vue?vue&type=style&index=0&id=31701c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31701c30",
  null
  
)

export default component.exports